export function capitalizeFirstLetter(str) {
    // Check if the string is not empty
    if (str && typeof str === 'string') {
        // Capitalize the first letter and concatenate the rest of the string
        return str.charAt(0).toUpperCase() + str.slice(1);
    } else {
        // Return the original string if it's empty or not a string
        return str;
    }
};